import React from 'react';
import { Link } from 'react-router-dom';

export function PictureSgGuide() {

    return (
        <section id="SchoolGuide">
            <div className="container-fluid mt-3 guide">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <p className="pageTitle text-center">Guide to Submit Request for Images from National Library, Singapore</p>
                            </div>

                            <div className="card mt-4 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/1.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Request for Images from National Library, Singapore
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Content/01.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Go to <a href="https://www.nas.gov.sg/erequest/">https://www.nas.gov.sg/erequest/</a>, click "Submit Request" tab, and select "National Library Online".
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/2.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Browse &<br />Add to Cart
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Content/02.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            <p>Search for the images on <a href={process.env.REACT_APP_PICTURESG_URL}>National Library Online</a>.<br />Add the images into your cart by selecting "Request a Copy".</p>
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/3.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Submit Request
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/content/03.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Click on cart to specify and confirm details of your request.
                                            Follow the step-by-step instructions to input your particulars and details of your use and submit your request.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/4.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Payment
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/content/05and06.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            For requests to reproduce images, some can be delivered immediately upon payment, while others require further processing. We will contact you for further clarifications within 3 to 5 working days.
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/5.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Delivery
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Marriage/05.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Upon completion of processing and payment (if any), we will email to notify of the delivery mode.
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <div className="guide_button mt-3">
                                <Link to={'/picturesg/disclaimer'} className="btn btn-primary theme-bg-color me-2">Start your search</Link>
                                <Link to={'/'} className="btn btn-secondary me-2">Back</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





